<section class="verification-page">
  <article class="verification-card" [class.success]="isSuccess" [class.error]="!isLoading && !isSuccess">
    <img src="assets/branding/logo.png" alt="" class="verification-logo">
    <div class="verification-icon">
      <i class="material-icons">{{ isLoading ? 'sync' : (isSuccess ? 'mark_email_read' : 'error') }}</i>
    </div>
    <p class="eyebrow">Email verification</p>
    <h1>{{ isLoading ? 'Confirming email' : (isSuccess ? 'Email confirmed' : 'Verification failed') }}</h1>
    <p>{{ message }}</p>
    <a routerLink="/login" class="btn btn-primary" *ngIf="!isLoading">
      <i class="material-icons">login</i>
      Go to login
    </a>
  </article>
</section>
